// extracted by mini-css-extract-plugin
export default {"sidebarMarketing":"b8V2t4bknqmTbdugkAMg","dummyclass":"ikgnIA3U3V4OtV9ZFtF0","pulse":"rRmroXkWI84ns4bGKLYn"};